import React, { Component } from "react";
import Layout from "../components/layouts";
import Hero from "../components/home/hero";
import About from "../components/home/About";
import Help from "../components/home/Help";
import StepProvide from "../components/home/StepProvide";
import Partner from "../components/home/Partner";
// import Employee2 from '../components/common/employee2'
import NewUpdate from "../components/common/newupdate";
import EmployeeList from "../components/common/employeelist";
import { logPageView, gaEvent } from "../ga/analytics";
// import PromotionIndex from "../components/common/promotionindex";
import { CATEGORY_HOMEPAGE, ACTION_REGISTER_BANNER } from "../ga/constant";

import imgTopBanner from "../assets/media/workshop-HRTABLExOffice365-01.jpg";

class App extends Component {
  constructor() {
    super();
    this.state = {
      isBanner: false,
    };
  }

  componentDidMount() {
    logPageView();
  }

  closeBanner() {
    this.setState({
      isBanner: false,
    });
  }

  sendToGa() {
    gaEvent(CATEGORY_HOMEPAGE, ACTION_REGISTER_BANNER);
  }

  render() {
    return (
      <Layout
        currentpage={this.props.match.url}
        page="homepage"
        match={this.props.match}
      >
        {this.state.isBanner ? (
          <div className="hrtable--modal--box--top">
            <button
              className="hrtable--modal--top-banner--close"
              title="close"
              style={{ fontSize: 20, color: "#111" }}
              onClick={() => this.closeBanner()}
            >
              <i className="icon ion-close" />
            </button>
            <a
              href="http://bit.ly/2E3YFnJ"
              onClick={() => this.sendToGa()}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className="hrtable--modal--top-banner"
                src={imgTopBanner}
                alt=""
              />
            </a>
          </div>
        ) : null}
        <Hero />
        <About />
        <Help />
        <StepProvide />
        <Partner />
        {/* <PromotionIndex /> */}
        <NewUpdate />
        <EmployeeList />
      </Layout>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/pages/index.jsx